export class Codificacion {
    idCodificacion: number;
    nombreDes: string;

	constructor(element=null) {
		if(!element)
			return;
		
		this.idCodificacion = element.idCodificacion;
		this.nombreDes = element.nombreDes;
	}
}